import styled from 'styled-components';
import { Col } from 'react-styled-flexboxgrid';

const FeaturedTopItem = styled(Col)`
  .item {
    background-color: white;
    height: 100%;
    border: 1px solid #e6eaeb;
    border-radius: 8px;
    max-width: auto;
    align-items: stretch;
    margin: auto;
    &:hover {
      cursor: pointer;
      box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.12);
    }
    .media {
      padding: 0;
      max-width: 150px;
      max-height: 125px;
      height: 125px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        outline: 1px solid transparent;
        border-radius: 8px;
      }
    }
    .description {
      margin: 8px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      header {
        display: flex;
        justify-content: space-between;
        .date,
        .location {
          img {
            vertical-align: sub;
          }
          span {
            color: #002f3f;
            margin-left: 10px;
          }
        }
      }
      .body {
        flex-grow: 1;
        .flex {
          display: flex;
          justify-content: space-between;
          p {
            margin-bottom: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.price {
              width & > div {
                margin: 0;
              }
            }
          }
          .title {
            font-size: 16px;
            font-weight: 600;
            color: #1c354f;
            margin: 8px 0;
          }
          .location {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            height: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #595959;
            flex-shrink: 1;
            overflow: hidden;
            img {
              height: 15px;
              width: 12px;
            }
            span {
              font-size: 13px;
              padding-left: 5px;
            }
          }
        }
        .flex-col {
          flex-direction: column;
          height: 100%;
        }
        .flex-row {
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
          .wrapper div {
            margin-top: 0;
          }
          .wrapper p {
            margin-bottom: 0;
          }
        }
        .desc {
          margin-top: 5px;
        }
      }
      footer {
      }
    }
  }
  @media only screen and (max-width: 580px) {
  }
`;

const FeaturedTopTag = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #00bcd4;
  height: 30px;
  border: 1px solid transparent;
  border-radius: 2px;
  font-family: 'Poppins';
  font-weight: bold;
  font-size: 12px;
  background-color: #e4f7fa;
  span {
    margin: 6px 10px;
    display: inline-block;
  }
  img {
    height: 16px;
    width: 17px;
    width: unset !important;
  }
`;

const FeaturedTopWrapper = styled('div')`
  background-color: #f1f1f1;
  border: 0px solid;
  border-radius: 8px;
  margin-bottom: 15px;
  margin-left: -30px;
  margin-right: -30px;
  height: 140px;
  &.empty {
    transition-delay: 0.7s;
    transition-duration: 0.2s;
    height: 0px;
  }
  &.show {
    transition-duration: 0.2s;
    height: 140px;
  }
  .hide-carousel {
    display: none;
  }
  .show-carousel {
    transition-delay: 0.2s;
    transition-duration: 0.2s;
    display: auto;
  }
  .owl-carousel {
    padding: 0 15px;
    position: relative;
    top: -35px;
    margin-top: 50px;
    .owl-nav {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 13px;
      margin-left: 5px;
      margin-right: 5px;
      button {
        outline: none;
      }
      button :hover {
        background: none;
      }
    }
    .owl-dots {
      position: relative;
      z-index: 0;
      top: -26px;
      .owl-dot {
        span {
          background: #00bcd4;
          width: 5px;
          height: 5px;
          margin: 5px 3px;
          transition: 0.3s;
        }
      }
      .owl-dot.active {
        span {
          width: 25px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export { FeaturedTopWrapper, FeaturedTopItem, FeaturedTopTag };
